import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import AmenitiesModal from "./AmenitiesModal";
import AllAmenities from "./AllAmenities";
// End

function Amenities() {
  const navigate = useNavigate();

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll] = React.useState("paper");
  // const handleClickOpen = (scrollType) => () => {
  //   setOpen(true);
  //   setScroll(scrollType);
  // };
  const handleClose = () => {
    setOpen(false);
  };
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  // End

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Amenities</h1>
            <Button
              className="contentTopLefBt contentTopLefBtSpace"
              onClick={() => navigate("/BookAmenities")}
            >
              Book Amenity
            </Button>

            <Button
              className="contentTopLefBt"
              onClick={() => navigate("/AddAmenity")}
            >
              Add Amenity
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <AllAmenities />
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        {/* <Button onClick={handleClickOpen("paper")}>scroll=paper</Button>
      <Button onClick={handleClickOpen("body")}>scroll=body</Button> */}
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Amenity</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <AmenitiesModal />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default Amenities;
